import axiosInstance from "api/axiosInstance";

import type { InstructorListItem, InstructorProfile, Certificate, SessionSchedule, LessonProduct, ScheduleListParams } from "api/types/instructor.types";
import type { PaginatedResponse } from "api/types/product.types";

export const instructorsService = {
  list: (params?: { sport?: number }) => axiosInstance.get<InstructorListItem[]>("/server/buccl_user/api/v1/instructors/", { params }),

  get: (userId: string) => axiosInstance.get<InstructorProfile>(`/server/buccl_user/api/v1/instructors/${userId}/`),

  updateStatus: (userId: string, isPublic: boolean) =>
    axiosInstance.patch<InstructorProfile>(`/server/buccl_user/api/v1/instructors/${userId}/`, {
      is_public: isPublic,
    }),

  listCertificates: (params?: { status?: string; user?: string; page?: number }) =>
    axiosInstance.get<PaginatedResponse<Certificate>>("/server/buccl_user/api/v1/certificates/", {
      params,
    }),

  approveCertificate: (id: number) => axiosInstance.post(`/server/buccl_user/api/v1/certificates/${id}/approve/`),

  rejectCertificate: (id: number) => axiosInstance.post(`/server/buccl_user/api/v1/certificates/${id}/reject/`),

  listSchedules: (params?: ScheduleListParams) => axiosInstance.get<PaginatedResponse<SessionSchedule>>("/server/buccl_lessons/api/v1/schedules/", { params }),

  listLessonProducts: (params?: { page?: number; instructor?: string; is_active?: boolean }) =>
    axiosInstance.get<PaginatedResponse<LessonProduct>>("/server/buccl_lessons/api/v1/products/", {
      params,
    }),
};
